export default __webpack_public_path__ + "static/media/image3.b80d9646.jpeg";